export default __webpack_public_path__ + "static/chrome.ebcff700eed3016169ba9f9d1a0c837e.png";